import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { changeLocale } from '@app/actions/global'
import _ from 'lodash'
import classnames from 'classnames'

const Language = ({ language, selected, onClick }) => {
  return (
    <a
      onClick={(e) => onClick(language)}
      href="javascript:void(0)"
      className={classnames("select-list__item", {
        "select-list__item--selected": selected?.code === language.code
      })}
    >
      <div className="select-list__mark">
      </div>
      <div className="select-list__option">
        { language.name }
      </div>
    </a>
  )
}

class LanguageList extends Component {
  constructor(props) {
    super(props)

    this.handleLanguageChange = this.handleLanguageChange.bind(this)
  }

  handleLanguageChange(selectedOption) {
    if (!selectedOption) { return }

    const { onChange, boundedChanger } = this.props
    const handler = onChange || boundedChanger

    handler(selectedOption.code)
  }

  get selectedLanguage() {
    const { languages, value } = this.props
    return _.find(languages, ['code', value || I18n.locale])
  }

  render() {
    const { languages } = this.props
    return (
      <div className="select-list">
        { _.map(languages, (x) => {
            return (
              <Language
                key={x.code}
                language={x}
                selected={this.selectedLanguage}
                onClick={this.handleLanguageChange} />
            )
          })
        }
      </div>
    )
  }
}

LanguageList.propTypes = {
  languages: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string
}

LanguageList.defaultProps = {

}

const mapDispatchToProps = (dispatch) => {
  const boundedChanger = bindActionCreators(changeLocale, dispatch)
  return { boundedChanger }
}

export default connect(null, mapDispatchToProps)(LanguageList)
